import zariaPic from "@/public/images/artists/zaria.jpg";
import { Artist } from "@/types/types";

export const zaria = {
  id: "300",
  name: "Zaria",
  image: zariaPic,
  description: `Zaria has a feather-light voice with a silky tone, airy texture, and an intimate, weightless feel.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fzaria-preview.mp3",
  meta: {
    free: false,
    new: true,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["RnB", "Unprocessed", "Indie", "Pop"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 56,
        high: 72,
      },
      sweetSpot: 63,
    },
  },
} as const satisfies Artist;
